import { render, staticRenderFns } from "./AddFileDialog.vue?vue&type=template&id=19470d22&scoped=true&"
import script from "./AddFileDialog.vue?vue&type=script&lang=js&"
export * from "./AddFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddFileDialog.vue?vue&type=style&index=0&id=19470d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19470d22",
  null
  
)

export default component.exports